import React from 'react';
import { SVGProps } from 'react';
import { SaneBlockChakra } from 'components/sanity/sane-block';

interface Resource {
  title: string;
  description: Record<string, unknown> | undefined;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
}
[];

interface ResourceCardProps {
  resource: Resource;
}

export function ResourceCard({ resource }: ResourceCardProps) {
  const Icon = resource.icon;
  return (
    <div key={resource.title}>
      <div className="pt-6">
        <div className="flow-root h-max rounded-2xl bg-white px-6 shadow-xl sm:h-80 md:h-72">
          <div className="-mt-6">
            <div>
              <span className="inline-flex items-center justify-center rounded-md bg-clerk-blue p-3 shadow-lg">
                <Icon className="h-6 w-6 text-white" />
              </span>
            </div>
            <h3 className="mt-8 text-lg font-medium tracking-tight text-gray-900">
              {resource.title}
            </h3>
            <p className="mt-5 mb-2 text-left text-base text-gray-500">
              <SaneBlockChakra blocks={resource.description?.richText} />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

ResourceCard.defaultProps = {};
